import { ColorHues, extendTheme } from '@chakra-ui/react';
import Text from './overrides/text';
import Button from './overrides/button';

const blackAlpha: ColorHues = {
  '50': 'rgba(0, 0, 0, 0.01)',
  '100': 'rgba(0, 0, 0, 0.1)',
  '200': 'rgba(0, 0, 0, 0.06)',
  '300': 'rgba(0, 0, 0, 0.12)',
  '400': 'rgba(0, 0, 0, 0.24)',
  '500': 'rgba(0, 0, 0, 0.36)',
  '600': 'rgba(0, 0, 0, 0.48)',
  '700': 'rgba(0, 0, 0, 0.60)',
  '800': 'rgba(0, 0, 0, 0.72)',
  '900': 'rgba(0, 0, 0, 0.84)',
};

export const whiteAlpha = {
  '50': 'rgba(255, 255, 255, 0.05)',
  '100': 'rgba(255, 255, 255, 0.1)',
  '150': 'rgba(255, 255, 255, 0.15)',
  '200': 'rgba(255, 255, 255, 0.2)',
  '300': 'rgba(255, 255, 255, 0.3)',
  '400': 'rgba(255, 255, 255, 0.4)',
  '500': 'rgba(255, 255, 255, 0.5)',
  '600': 'rgba(255, 255, 255, 0.6)',
  '700': 'rgba(255, 255, 255, 0.7)',
  '800': 'rgba(255, 255, 255, 0.8)',
  '900': 'rgba(255, 255, 255, 0.9)',
};

export const colors = {
  blackAlpha,
  whiteAlpha,
};

const theme = extendTheme({
  colors: {
    primary: '#F6F6F6',
    secondary: '#949494',
    warn: '#C40E3A'
  },
  components: {
    Text,
    Button,
    Input: {
      variants: {
        outline: {
          field: {
            _focusVisible: {
              borderColor: '#42E365',
              boxShadow: '0 0 0 1px #42E365',
            },
          },
        },
      },
    },
    Textarea: {
      variants: {
        outline: {
          _focusVisible: {
            borderColor: '#42E365',
            boxShadow: '0 0 0 1px #42E365',
          },
        },
      },
    },
    Select: {
      variants: {
        outline: {
          field: {
            _focusVisible: {
              borderColor: '#42E365',
              boxShadow: '0 0 0 1px #42E365',
            },
          },
        },
      },
    },
    Tooltip: {
      baseStyle: {
        bg: 'white',
        color: 'blackAlpha.800',
        fontSize: 'sm',
        fontWeight: '400',
        px: 3,
        py: 1.5,
        borderRadius: 6,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12)',
        '--popper-arrow-bg': 'white',
      },
    },
    Modal: {
      baseStyle: {
        overlay: {
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
  fonts: {
    body: `'Sora', sans-serif`,
  },
});

export default theme;
